// extracted by mini-css-extract-plugin
export default {"addressSection":"GU-z","disabled":"HU-z","sectionButtons":"IU-z","logo":"JU-z"};